import React from "react";
import RequesterDashboard from "./RequesterDashboard";

const AgencyDashboard = () => (
  <RequesterDashboard
    title="Espace Agence / Professionnel"
    subtitle="Déposez et suivez vos demandes d'intervention"
    showTenant
    role="agence"
  />
);

export default AgencyDashboard;
